<template>
  <form @submit.prevent="onLoginAction" method="post" class="user">
    <div 
      :class="{ 'd-none': !onErrorMsg }"
      class="alert alert-danger alert-icon">
        <em class="icon ni ni-cross-circle"></em> 
        <strong>¡Error de inicio de sesion!</strong>
        <ul>
            <li v-for="(error, index) in arrayErrors" :key="index">{{error}}</li>
        </ul>
    </div>
    <div class="form-group">
      <input 
      v-model="form.email"
      type="email" 
      class="form-control" 
      id="exampleInputEmail"
      aria-describedby="emailHelp" 
      placeholder="Correo electronico">
    </div>
    <div class="form-group">
      <input 
      v-model="form.password"
      type="password" 
      class="form-control" 
      id="exampleInputPassword" 
      placeholder="Contraseña">
    </div>
    <button 
    :disabled="onLoadForm"
    type="submit" 
    class="btn btn-dark btn-block">
        <clip-loader
        :class="{ 'd-none': !onLoadForm }"
        style="display: inline;margin-right: 10px;"  
        color="#fff" 
        size="15px"></clip-loader>
        Ingresar
    </button>
  </form>
</template>

<script>
    import axios from 'axios';
    export default {
        data() {
          return {
            form: {
              email: '',
              password: ''
            },
            onLoadForm: false,
            onErrorMsg: false,
            arrayErrors: []
          }
        },
        methods: {
            onLoginAction() {
                this.onLoadForm = true;
                this.onErrorMsg = false;
                this.arrayErrors = [];
                axios.post('/ajax/login', this.form).then((response) =>{
                    var parseRes = response.data;
                    //console.log(">>>>", parseRes);
                    if(parseRes.response == 'error'){
                        this.onErrorMsg = true;
                        this.arrayErrors = parseRes.errors;
                        this.onLoadForm = false;
                    }else{
                      setTimeout(function(){
                        window.location.href = '/admin/home';
                      }, 500);
                    }
                });
            }
        },
    }
</script>

<style lang="scss">
a.small {
    color: #b9b9b9;
    font-weight: 600;
    font-size: 100%;
}
</style>